import React from 'react';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import { IoWalletOutline, IoWallet } from "react-icons/io5"


function MyModal(props) {

  return (
    <>
      <Modal show={props?.show} onHide={props?.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{props?.heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        
          {props?.children}

        </Modal.Body>
      </Modal>
    </>
  );
}

export default MyModal;